import React from "react";

import image0 from "../../../static/brand/0.png";
import image1 from "../../../static/brand/1.png";
import image2 from "../../../static/brand/2.png";
import image3 from "../../../static/brand/3.png";
import image4 from "../../../static/brand/4.png";
import image5 from "../../../static/brand/5.png";
import image6 from "../../../static/brand/6.png";
import image7 from "../../../static/brand/7.png";
import image8 from "../../../static/brand/8.png";
import image9 from "../../../static/brand/9.png";
import image10 from "../../../static/brand/10.png";
import image11 from "../../../static/brand/11.png";
import image12 from "../../../static/brand/12.png";
import image13 from "../../../static/brand/13.png";
import image14 from "../../../static/brand/14.png";
import image15 from "../../../static/brand/15.png";
import image16 from "../../../static/brand/16.png";
import image17 from "../../../static/brand/17.png";
import image18 from "../../../static/brand/18.png";
import image19 from "../../../static/brand/19.png";
import image20 from "../../../static/brand/20.png";

const OurClient: React.FC = () => (
  <div className="relative bg-black">
    <div
      className="py-12 px-8 mx-auto"
      style={{
        maxWidth: "1150px",
        fontSize: "26px",
      }}
    >
      <h1 className="gradient-text" style={{ width: "max-content" }}>
        Our Clients
      </h1>
      <h1 className="text-white">ร้านค้าที่เลือกใช้ deeple</h1>

      <div className="grid grid-cols-3 gap-4 mt-8 sm:grid-cols-7">
        <img src={image0} />
        <img src={image1} />
        <img src={image2} />
        <img src={image3} />
        <img src={image4} />
        <img src={image5} />
        <img src={image6} />
        <img src={image7} />
        <img src={image8} />
        <img src={image9} />
        <img src={image10} />
        <img src={image11} />
        <img src={image12} />
        <img src={image13} />
        <img src={image14} />
        <img src={image15} />
        <img src={image16} />
        <img src={image17} />
        <img src={image18} />
        <img src={image19} />
        <img src={image20} />
      </div>
    </div>
  </div>
);

export default OurClient;
